module.exports = __webpack_public_path__ + "img/1.be2cdb71.jpg";